"use client";

import { useEffect, useState } from "react";
import {
  MapPin,
  Calendar,
  Clock,
  DollarSign,
  Users,
  Info,
  Tag,
  Building,
  AlertCircle,
  Car,
  Train,
  Bike,
  Footprints
} from "lucide-react";
import MainLayout from "../components/MainLayout";
import { useParams } from "react-router-dom";
import {
  fetchCommercialEventById,
  fetchCommunityEventById
} from "../services/events";
import { transformEventData } from "../utils/helpers";

export default function EventDetails() {
  const [isFavorite, setIsFavorite] = useState(false);
  const [activeTab, setActiveTab] = useState("details");

  const toggleFavorite = () => {
    setIsFavorite(!isFavorite);
  };

  const { slug, category, id } = useParams();
  const [eventDetail, setEventDetail] = useState(null);

  useEffect(
    () => {
      if (!id) return;

      async function fetchEventDetails() {
        if (category.toLowerCase() === "community") {
          const event = await fetchCommunityEventById(id);
          const transformedEvent = transformEventData(event.data);

          console.log("event", transformedEvent);
          setEventDetail(transformedEvent);
        } else {
          const event = await fetchCommercialEventById(id);

          const transformedEvent = transformEventData(event.data);
          console.log("transformedEventcommercial", transformedEvent);
          setEventDetail(transformedEvent);
        }
      }
      fetchEventDetails();
    },
    [id]
  );

  const getValue = (value, defaultValue = "N/A") => {
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }
    return value;
  };

  const formatAddress = address => {
    if (!address) return "N/A";
    return address.replace(/\r\n\s+/g, ", ").trim();
  };

  return (
    <MainLayout rs={false}>
      {eventDetail && (
        <div className="flex-1 overflow-auto w-full">
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 overflow-y-auto">
              <div className="relative">
                <img
                  src={
                    eventDetail.image ||
                    eventDetail.cover_image ||
                    "/placeholder.svg"
                  }
                  alt={getValue(eventDetail.title) || eventDetail.name}
                  className="w-full h-[300px] sm:h-[400px] object-cover rounded-lg"
                  onError={e => {
                    e.currentTarget.src = "/placeholder.jpg";
                  }}
                />

                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 sm:p-6">
                  <div className="bg-white rounded-full px-3 py-1 text-xs font-medium flex items-center w-fit mb-2">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mr-1"
                    >
                      <path
                        d="M22 10C22 14.4183 17.5228 19 12 19C6.47715 19 2 10 2 5.58172 6.47715 2 12 2C17.5228 2 22 5.58172 22 10Z"
                        fill="#F5F3F5"
                      />
                      <path
                        d="M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10Z"
                        fill="#7B189F"
                      />
                      <path
                        d="M6 10H4.5M19.5 10H18M7.5 14.5L6.5 15.5M16.5 14.5L17.5 15.5M7.5 5.5L6.5 4.5M16.5 5.5L17.5 4.5"
                        stroke="#7B189F"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {getValue(
                      eventDetail.category ||
                        (eventDetail.performers && eventDetail.performers[0]) ||
                        category
                    )}
                  </div>
                  <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                    {getValue(eventDetail.title || eventDetail.name)}
                  </h1>
                  <div className="flex items-center text-white">
                    <div className="flex items-center">
                      <Calendar className="h-4 w-4 text-white" />
                      <span className="ml-1 font-semibold">
                        {getValue(
                          eventDetail.date.includes("T")
                            ? eventDetail.date.split("T")[0]
                            : eventDetail.date
                        )}

                        <br />
                        {eventDetail.time && getValue(eventDetail.time)}

                        {eventDetail.eventstarttime &&
                          `${eventDetail.eventstarttime
                            .split(":")
                            .slice(0, 2)
                            .join(":")} - ${eventDetail.eventendtime
                            .split(":")
                            .slice(0, 2)
                            .join(":")}`}
                      </span>
                    </div>
                  </div>
                  {eventDetail.status && (
                    <div className="mt-2 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium inline-block">
                      {eventDetail.status}
                    </div>
                  )}
                </div>
              </div>

              <div className="border-b border-[#F5E8EA] sticky top-0 bg-white z-10">
                <div className="flex overflow-x-auto scrollbar-hide">
                  <button
                    onClick={() => setActiveTab("details")}
                    className={`px-4 py-3 font-medium text-sm whitespace-nowrap ${
                      activeTab === "details"
                        ? "text-[#7b189f] border-b-2 border-[#7b189f]"
                        : "text-[#4f4d4f]"
                    }`}
                  >
                    Event Details
                  </button>
                  {eventDetail.ticket_information &&
                    eventDetail.ticket_information.ticket_types &&
                    eventDetail.ticket_information.ticket_types.length > 0 && (
                      <button
                        onClick={() => setActiveTab("tickets")}
                        className={`px-4 py-3 font-medium text-sm whitespace-nowrap ${
                          activeTab === "tickets"
                            ? "text-[#7b189f] border-b-2 border-[#7b189f]"
                            : "text-[#4f4d4f]"
                        }`}
                      >
                        Tickets
                      </button>
                    )}
                  <button
                    onClick={() => setActiveTab("venue")}
                    className={`px-4 py-3 font-medium text-sm whitespace-nowrap ${
                      activeTab === "venue"
                        ? "text-[#7b189f] border-b-2 border-[#7b189f]"
                        : "text-[#4f4d4f]"
                    }`}
                  >
                    Venue
                  </button>
                  {eventDetail.artist_details &&
                    eventDetail.artist_details.name != "" && (
                      <button
                        onClick={() => setActiveTab("artist")}
                        className={`px-4 py-3 font-medium text-sm whitespace-nowrap ${
                          activeTab === "artist"
                            ? "text-[#7b189f] border-b-2 border-[#7b189f]"
                            : "text-[#4f4d4f]"
                        }`}
                      >
                        Artist
                      </button>
                    )}
                  {eventDetail.organizer_details &&
                    eventDetail.organizer_details.name != "" && (
                      <button
                        onClick={() => setActiveTab("organizer")}
                        className={`px-4 py-3 font-medium text-sm whitespace-nowrap ${
                          activeTab === "organizer"
                            ? "text-[#7b189f] border-b-2 border-[#7b189f]"
                            : "text-[#4f4d4f]"
                        }`}
                      >
                        Organizer
                      </button>
                    )}
                </div>
              </div>

              <div className="p-4 sm:p-6">
                {activeTab === "details" && (
                  <div>
                    <h2 className="text-xl font-bold mb-4">About This Event</h2>
                    <p className="text-[#232123] text-sm sm:text-base leading-relaxed whitespace-pre-line">
                      {getValue(eventDetail.description)}
                    </p>

                    <div className="mt-6 rounded-2xl overflow-hidden border border-[#F5E8EA]">
                      <div className="bg-white p-4 space-y-4">
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                            <MapPin className="h-4 w-4 text-[#7b189f]" />
                          </div>
                          <div className="ml-3">
                            <p className="text-[#232123] text-[15px] font-medium">
                              {getValue(eventDetail.venue)}
                            </p>
                            <p className="text-[#4f4d4f] text-[13px]">
                              {getValue(eventDetail.location)}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                            <Calendar className="h-4 w-4 text-[#7b189f]" />
                          </div>
                          <div className="ml-3">
                            <p className="text-[#232123] text-[15px]">
                              {getValue(
                                eventDetail.date.includes("T")
                                  ? eventDetail.date.split("T")[0]
                                  : eventDetail.date
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                            <Clock className="h-4 w-4 text-[#7b189f]" />
                          </div>
                          <div className="ml-3">
                            <p className="text-[#232123] text-[15px]">
                              {eventDetail.time && getValue(eventDetail.time)}

                              {eventDetail.eventstarttime &&
                                `${eventDetail.eventstarttime
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")} - ${eventDetail.eventendtime
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")}`}
                            </p>
                          </div>
                        </div>
                        {eventDetail.price && (
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                              <DollarSign className="h-4 w-4 text-[#7b189f]" />
                            </div>
                            <div className="ml-3">
                              <p className="text-[#232123] text-[15px]">
                                {getValue(eventDetail.price)}
                              </p>
                            </div>
                          </div>
                        )}
                        {eventDetail.performers.length > 0 && (
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                              <Users className="h-4 w-4 text-[#7b189f]" />
                            </div>
                            <div className="ml-3">
                              <p className="text-[#232123] text-[15px]">
                                Performers:{" "}
                                {getValue(
                                  eventDetail.performers
                                    ? eventDetail.performers.join(", ")
                                    : null
                                )}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                            <Tag className="h-4 w-4 text-[#7b189f]" />
                          </div>
                          <div className="ml-3">
                            <p className="text-[#232123] text-[15px]">
                              Category:{" "}
                              {getValue(eventDetail.category || category)}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center">
                          <div className="w-8 h-8 bg-[#f8f0ff] rounded-full flex items-center justify-center flex-shrink-0">
                            <Info className="h-4 w-4 text-[#7b189f]" />
                          </div>
                          <div className="ml-3">
                            <p className="text-[#232123] text-[15px]">
                              Status: Active
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "tickets" && (
                  <div>
                    <h2 className="text-xl font-bold mb-4">
                      {getValue(
                        eventDetail.ticket_information?.title,
                        "Ticket Information"
                      )}
                    </h2>

                    <div className="text-center p-6 border border-dashed border-[#F5E8EA] rounded-lg">
                      <p className="text-[#4f4d4f]">
                        Ticket sales not available currently on the platform.
                        More info coming soon.
                      </p>
                    </div>
                  </div>
                )}

                {activeTab === "venue" && (
                  <div>
                    <h2 className="text-xl font-bold mb-4">
                      Venue Information
                    </h2>

                    {eventDetail.venue_details ? (
                      <div>
                        <div className="border border-[#F5E8EA] rounded-lg p-4 mb-4">
                          <h3 className="font-semibold text-lg mb-2">
                            {getValue(eventDetail.venue_details.name)}
                          </h3>
                          <p className="text-[#4f4d4f] mb-3">
                            {formatAddress(
                              eventDetail.venue_details.full_address
                            )}
                          </p>

                          <div className="grid grid-cols-2 gap-2 mt-4">
                            {eventDetail.street_address &&
                              eventDetail.street_address != "" && (
                                <div className="text-sm">
                                  <p className="text-[#4f4d4f]">
                                    Street Address
                                  </p>
                                  <p className="font-medium">
                                    {getValue(
                                      eventDetail.venue_details.street_address
                                    )}
                                  </p>
                                </div>
                              )}
                            <div className="text-sm">
                              <p className="text-[#4f4d4f]">City</p>
                              <p className="font-medium">
                                {getValue(eventDetail.venue_details.city)}
                              </p>
                            </div>
                            <div className="text-sm">
                              <p className="text-[#4f4d4f]">State</p>
                              <p className="font-medium">
                                {getValue(eventDetail.venue_details.state)}
                              </p>
                            </div>
                            {eventDetail.zip_code && (
                              <div className="text-sm">
                                <p className="text-[#4f4d4f]">Zip Code</p>
                                <p className="font-medium">
                                  {getValue(eventDetail.venue_details.zip_code)}
                                </p>
                              </div>
                            )}
                          </div>
                        </div>

                        {eventDetail.venue_details.map_url && (
                          <div className="rounded-xl overflow-hidden h-64 bg-gray-200 mb-4">
                            <img
                              src={
                                eventDetail.venue_details.map_url ||
                                "/placeholder.svg"
                              }
                              alt={getValue(
                                eventDetail.venue_details.map_title,
                                "Event location map"
                              )}
                              className="w-full h-full object-cover"
                            />
                          </div>
                        )}

                        {eventDetail.venue_details.navigation_links && (
                          <div className="mt-4">
                            <p className="text-[#4f4d4f] font-medium mb-2">
                              Available Direction Types:
                            </p>
                            <div className="flex flex-wrap gap-3">
                              <div
                                onClick={() =>
                                  window.open(
                                    eventDetail.venue_details.navigation_links
                                      .driving,
                                    "_blank"
                                  )
                                }
                                className="cursor-pointer flex items-center gap-1 text-[#4f4d4f]"
                              >
                                <Car className="h-4 w-4 text-[#7b189f]" />
                                <span>Driving</span>
                              </div>
                              <div
                                onClick={() =>
                                  window.open(
                                    eventDetail.venue_details.navigation_links
                                      .transit,
                                    "_blank"
                                  )
                                }
                                className="flex cursor-pointer items-center gap-1 text-[#4f4d4f]"
                              >
                                <Train className="h-4 w-4 text-[#7b189f]" />
                                <span>Transit</span>
                              </div>
                              <div
                                onClick={() =>
                                  window.open(
                                    eventDetail.venue_details.navigation_links
                                      .biking,
                                    "_blank"
                                  )
                                }
                                className="flex cursor-pointer items-center gap-1 text-[#4f4d4f]"
                              >
                                <Bike className="h-4 w-4 text-[#7b189f]" />
                                <span>Biking</span>
                              </div>
                              <div
                                onClick={() =>
                                  window.open(
                                    eventDetail.venue_details.navigation_links
                                      .walking,
                                    "_blank"
                                  )
                                }
                                className="flex cursor-pointer items-center gap-1 text-[#4f4d4f]"
                              >
                                <Footprints className="h-4 w-4 text-[#7b189f]" />
                                <span>Walking</span>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div className="text-center p-6 border border-dashed border-[#F5E8EA] rounded-lg">
                        <p className="text-[#4f4d4f]">
                          No venue details available
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "artist" && (
                  <div>
                    <h2 className="text-xl font-bold mb-4">
                      Artist Information
                    </h2>

                    {eventDetail.artist_details ? (
                      <div className="border border-[#F5E8EA] rounded-lg p-4">
                        <div className="flex flex-col sm:flex-row gap-4">
                          {eventDetail.artist_details.image && (
                            <div className="w-full sm:w-1/3">
                              <img
                                src={
                                  eventDetail.artist_details.image ||
                                  "/placeholder.svg"
                                }
                                alt={getValue(
                                  eventDetail.artist_details.image_alt,
                                  "Artist image"
                                )}
                                className="w-full h-auto rounded-lg object-cover aspect-square"
                                onError={e => {
                                  e.currentTarget.src = "/placeholder.jpg";
                                }}
                              />
                            </div>
                          )}

                          <div className="flex-1">
                            <h3 className="font-semibold text-lg mb-2">
                              {getValue(eventDetail.artist_details.name)}
                            </h3>
                            <p className="text-[#4f4d4f] mb-4">
                              {getValue(eventDetail.artist_details.description)}
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center p-6 border border-dashed border-[#F5E8EA] rounded-lg">
                        <p className="text-[#4f4d4f]">
                          No artist details available
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {activeTab === "organizer" && (
                  <div>
                    <h2 className="text-xl font-bold mb-4">
                      {getValue(
                        eventDetail.organizer_details?.title,
                        "Organizer Information"
                      )}
                    </h2>

                    {eventDetail.organizer_details ? (
                      <div className="border border-[#F5E8EA] rounded-lg p-4">
                        <div className="flex items-center gap-4 mb-4">
                          {eventDetail.organizer_details.logo && (
                            <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                              <img
                                src={
                                  eventDetail.organizer_details.logo ||
                                  "/placeholder.svg"
                                }
                                alt={getValue(
                                  eventDetail.organizer_details.logo_title,
                                  "Organizer logo"
                                )}
                                className="w-full h-full object-cover"
                                onError={e => {
                                  e.currentTarget.src = "/placeholder.jpg";
                                }}
                              />
                            </div>
                          )}

                          <div>
                            <h3 className="font-semibold text-lg">
                              {getValue(eventDetail.organizer_details.name)}
                            </h3>
                            {eventDetail.organizer_details
                              .upcoming_events_count && (
                              <p className="text-[#4f4d4f] text-sm">
                                {
                                  eventDetail.organizer_details
                                    .upcoming_events_count
                                }{" "}
                                upcoming events
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mt-3 flex items-center gap-2 text-[#4f4d4f]">
                          <Building className="h-4 w-4 text-[#7b189f]" />
                          <span>This organizer has more upcoming events</span>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center p-6 border border-dashed border-[#F5E8EA] rounded-lg">
                        <p className="text-[#4f4d4f]">
                          No organizer details available
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
}
